import React from 'react';
import { LabelInput } from 'components/atoms/Inputs/LabelInput';
import { AccountFieldsForm } from '../../../../types/user/user.def';

interface AccountFieldsProps {
  handleChange: (e: any) => any;
  errors: any;
  fields: AccountFieldsForm;
}

export const AccountFields = ({
  handleChange,
  errors,
  fields: { firstname, lastname, email, tel }
}: AccountFieldsProps): JSX.Element => {
  return (
    <>
      <LabelInput
        placeHolder="Prénom : Champ obligatoire"
        name="firstName"
        label="Prénom"
        value={firstname || ''}
        onChange={handleChange('firstname')}
        error={errors.firstname}
        required={true}
      />
      <LabelInput
        placeHolder="Nom de famille : Champ obligatoire"
        name="lastName"
        label="Nom de famille"
        value={lastname || ''}
        onChange={handleChange('lastname')}
        error={errors.lastname}
        required={true}
      />
      <LabelInput
        placeHolder="Email : Champ obligatoire"
        name="Email"
        label="Adresse Email"
        value={email || ''}
        onChange={handleChange('email')}
        error={errors.email}
        required={true}
      />
      <LabelInput
        placeHolder="Téléphone : Champ obligatoire"
        name="Tel"
        label="Téléphone"
        value={tel || ''}
        onChange={handleChange('tel')}
        error={errors.tel}
        required={true}
        type="tel"
      />
    </>
  );
};
